import {
  API_VEICULOS,
  API_ACOPLAMENTOS,
  API_ORDENS_SERVICO,
  API_ORDENS_TRANSPORTE,
  API_CHECKLIST_TEMPLATES,
  API_CHECKLISTS,
} from '../api/apiConfig';
import {
  Veiculo,
  Acoplamento,
  OrdemServico,
  OrdemTransporte,
  ChecklistTemplate,
  Checklist,
} from '../types/logistica';
import { createCrudService } from './crudFactory';

export const veiculosService = createCrudService<Veiculo>(API_VEICULOS);
export const acoplamentosService = createCrudService<Acoplamento>(API_ACOPLAMENTOS);
export const ordensServicoService = createCrudService<OrdemServico>(API_ORDENS_SERVICO);
export const ordensTransporteService = createCrudService<OrdemTransporte>(API_ORDENS_TRANSPORTE);
export const checklistTemplatesService = createCrudService<ChecklistTemplate>(API_CHECKLIST_TEMPLATES);
export const checklistsService = createCrudService<Checklist>(API_CHECKLISTS);
